import * as React from 'react';
import type { SVGProps } from 'react';
import type { IconProps, ForwardedIconComponent } from './types';
const SlidersFilled = (React.forwardRef<SVGSVGElement, SVGProps<SVGSVGElement> & IconProps>(function SlidersFilled({
  title,
  titleId,
  size = '1em',
  ...props
}, ref) {
  return <svg width={size} height={size} viewBox="0 0 24 24" fill="none" ref={ref} aria-labelledby={titleId} {...props}>
        {title ? <title id={titleId}>{title}</title> : null}
        <g fill="currentColor">
          <path d="M9.72 8.5c-.62 1.74-2.26 3-4.22 3C3.01 11.5 1 9.49 1 7s2.01-4.5 4.5-4.5c1.95 0 3.6 1.26 4.22 3H22.5v3H9.72ZM14.28 15.5c.62-1.74 2.26-3 4.22-3 2.49 0 4.5 2.01 4.5 4.5s-2.01 4.5-4.5 4.5c-1.95 0-3.6-1.26-4.22-3H1.5v-3h12.78Z" />
        </g>
      </svg>;
}) as ForwardedIconComponent);
export default SlidersFilled;